export default __webpack_public_path__ + "static/media/FSKoopman-Regular.23801b68.woff";